var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 244,
    viewBox: "0 0 172 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1759_20280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.366 120.781L212.763 157.064C214.095 158.076 215.135 159.424 215.776 160.97C216.417 162.515 216.636 164.203 216.412 165.861C216.188 167.519 215.528 169.088 214.5 170.408C213.471 171.727 212.111 172.751 210.558 173.373L124.715 208.247C121.643 209.507 118.293 209.936 115.002 209.491C111.712 209.046 108.596 207.743 105.969 205.712L32.4703 149.292C31.1383 148.28 30.0988 146.932 29.4578 145.387C28.8167 143.841 28.5971 142.153 28.8213 140.495C29.0455 138.837 29.7055 137.268 30.7339 135.949C31.7624 134.629 33.1225 133.606 34.6756 132.983L90.0068 110.591M134.854 133.261C131.782 134.521 128.432 134.951 125.142 134.506C121.851 134.061 118.735 132.757 116.108 130.727L42.6097 74.307C41.2777 73.2945 40.2382 71.9467 39.5972 70.4013C38.9561 68.8558 38.7365 67.168 38.9607 65.51C39.1849 63.8519 39.8449 62.283 40.8733 60.9634C41.9018 59.6437 43.2619 58.6204 44.815 57.9979L130.658 23.1242C133.73 21.8643 137.08 21.4352 140.371 21.8801C143.661 22.3251 146.777 23.6284 149.404 25.659L222.903 82.0787C224.235 83.0912 225.274 84.439 225.915 85.9844C226.556 87.5299 226.776 89.2177 226.552 90.8757C226.327 92.5338 225.667 94.1026 224.639 95.4223C223.61 96.742 222.25 97.7653 220.697 98.3878L134.854 133.261Z",
    stroke: "url(#paint0_linear_1759_20280)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1759_20280",
    x1: 2.00012,
    y1: 38.5,
    x2: 219,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#217753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A368"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1759_20280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 227,
    fill: "white",
    transform: "translate(30.4177 -12) rotate(7.70074)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairs);
export default __webpack_public_path__ + "static/media/pairs.8fa61684c85f1a760dcf627ccfeb16c1.svg";
export { ForwardRef as ReactComponent };